import { CommonModule, DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CustomerAccountingImportDTO, PagedRequest } from '../model';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FileUpload, FileUploadHandlerEvent, FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { CustomerAccountingService } from '../customer-accounting.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-customer-accounting-list',
  imports: [FormsModule, InputTextModule, FileUploadModule, DialogModule, CommonModule,
    TableModule, ButtonModule, ToolbarModule, DatePickerModule,
    DatePipe,
    InputNumberModule, SelectModule,
    ConfirmDialog],
  providers: [ConfirmationService],
  templateUrl: './customer-accounting-list.component.html',
  styleUrl: './customer-accounting-list.component.scss'
})
export class CustomerAccountingListComponent {

  date = new Date();
  importDialogVisible = false;
  @ViewChild('fu')
  fu: FileUpload | undefined;

  constructor(private service: CustomerAccountingService,
    private confirmationService: ConfirmationService,
    private router: Router) {
  }

  public req: PagedRequest = {
    page: 0,
    pageSize: 20,
  };

  protected data: CustomerAccountingImportDTO[] = [];
  protected total: number = 0;
  protected isLoading: boolean = false;
  protected nowLoadingModal: boolean = false;

  showImportDialog() {
    this.importDialogVisible = true;
  }

  onUpload(event: FileUploadHandlerEvent) {
    if (event.files.length > 0) {
      const file = event.files[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      //formData.append('JSONData', new Blob([JSON.stringify({ date: new Date() })], { type: 'application/json' }));
      // format this.date to a string
      let date = new Date(this.date.setTime(this.date.getTime() + (5 * 60 * 60 * 1000))); // add five hours to prevent hour diff
      formData.append('JsonData', JSON.stringify({ date: date }));

      this.nowLoadingModal = true;
      this.importDialogVisible = false;

      this.service.import(formData).subscribe(response => {
        this.nowLoadingModal = false;
        this.router.navigate(['/accounting/tabs/' + this.formatDate(date)]);
      }, error => {
        console.error('File upload failed', error);
      });
    }
  }

  submitUpload() {
    if (this.fu) {
      this.fu.upload();
    }
  }

  loadDataLazy(ev: TableLazyLoadEvent) {
    this.req.page = ev.first ?? 0;

    this.service.list({
      pageSize: this.req.pageSize,
      page: this.req.page / this.req.pageSize,
      //orderBy: this.req.orderBy,
      //orderASC: this.req.orderASC,
    }).subscribe(data => {
      this.data = data.items;
      this.total = data.total;
    });
  }

  deleteDate(event: Event, date: Date) {
    event?.preventDefault();

    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Are you sure you want to delete this date?',
      accept: () => {
        this.service.deleteAll(new Date(date)).subscribe(() => {
          this.refresh();
        });
      }
    });
  }

  refresh() {
    this.loadDataLazy({ first: 0 });
  }

  formatDate(date: Date): string {
    return new Date(date).getTime() + "";
  }
}
